{
  "name": "stammdatenverwaltung",
  "version": "3.9.10",
  "builddate": "01.08.2026 13:00",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:host": "ng serve --host 0.0.0.0 --port 4200 --disable-host-check",
    "build": "ng build",
    "build:prod": "ng build --aot --configuration production",
    "build:prod-smw": "ng build --aot --configuration production",
    "build:test": "ng build --configuration test",
    "build:stage": "ng build --configuration staging",
    "build:test-smw": "ng build --configuration test",
    "build:stage-smw": "ng build --configuration staging",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "18.2.14",
    "@angular/cdk": "18.2.14",
    "@angular/common": "18.2.14",
    "@angular/compiler": "18.2.14",
    "@angular/core": "18.2.14",
    "@angular/forms": "18.2.14",
    "@angular/material": "18.2.14",
    "@angular/platform-browser": "18.2.14",
    "@angular/platform-browser-dynamic": "18.2.14",
    "@angular/router": "18.2.14",
    "@angular/service-worker": "18.2.14",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-brands-svg-icons": "^7.2.0",
    "@fortawesome/free-regular-svg-icons": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@ngneat/cashew": "^5.3.0",
    "@sentry/angular": "^8.13.0",
    "@sentry/cli": "^2.58.5",
    "bootstrap": "^5.3.8",
    "bs-custom-file-input": "^1.3.4",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "flag-icons": "^7.5.0",
    "google-libphonenumber": "^3.2.44",
    "i18n-iso-countries": "^7.10.0",
    "jsvat": "^2.5.3",
    "keycloak-angular": "^16.1.0",
    "keycloak-js": "^25.0.6",
    "moment": "^2.0.0",
    "ngx-cookie-service": "^18.0.0",
    "ngx-mat-select-search": "^8.0.4",
    "read-excel-file": "^5.8.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.21",
    "@angular-eslint/builder": "18.4.3",
    "@angular-eslint/eslint-plugin": "18.4.3",
    "@angular-eslint/eslint-plugin-template": "18.4.3",
    "@angular-eslint/schematics": "18.4.3",
    "@angular-eslint/template-parser": "18.4.3",
    "@angular/cli": "18.2.21",
    "@angular/compiler-cli": "18.2.14",
    "@types/file-saver": "^2.0.7",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jasmine": "~4.3.0",
    "@types/node": "^20.19.37",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "eslint": "^8.57.0",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "typescript": "~5.5.4"
  }
}